import * as React from 'react';
import moment from 'moment';
import { QuantitySelectProps } from '../../components/cart/quantity-select';

const QuantitySelectView: React.StatelessComponent<QuantitySelectProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const selectedValue = +evt.currentTarget.value;
        const priceTypeId = +evt.currentTarget.options[evt.currentTarget.selectedIndex].getAttribute('data-price-type');
        props.selectPriceTypeQuantity(priceTypeId, selectedValue);
    }

    function handlePlus(priceTypeId: number) {
        var quantity = getPriceTypeQuantity(priceTypeId);
        if (quantity != 10) {
            props.selectPriceTypeQuantity(priceTypeId, quantity + 1);
        }
    }

    function getPriceTypeQuantity(priceTypeId: number): number {
        var quantity = 0;
        var priceQuantity = props.selectedPriceTypeQuantities.get(priceTypeId);
        if (priceQuantity != undefined)
            quantity = priceQuantity;
        return quantity;
    }

    function handleMinus(priceTypeId: number) {
        var quantity = getPriceTypeQuantity(priceTypeId);
        if (quantity > 0) {
            props.selectPriceTypeQuantity(priceTypeId, quantity - 1);
        }
    }

    function handleValueChange(e, priceTypeId: number) {
        e.preventDefault();
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
            const x = Number(e.target.value);
            props.selectPriceTypeQuantity(priceTypeId, x);
        }
    }

    const qtySelect = (
        <>
            {
                props.packagePriceTypes.map(pt => {
                    var selectName = "quantity" + pt.priceTypeId;

                    var options = Array.from(Array(pt.maxSeats + 1).keys());

                    const selectedQuantity = props.selectedPriceTypeQuantities.get(pt.priceTypeId) ? props.selectedPriceTypeQuantities.get(pt.priceTypeId) : 0;

                    return <div className={`stack-xs`} key={pt.priceTypeId}>
                        <label className="visually-hidden" htmlFor={selectName}>{props.selectTicketsText}</label>
                        <p>{pt.description}</p>
                        <div className="stepper stepper-full"
                            data-stepper-min="0" data-stepper-max={pt.maxSeats}
                            data-stepper-step-amount="1"
                            data-stepper-label-up="Add <<steps>> item to <<sum>>."
                            data-stepper-label-down="Remove <<steps>> item from <<sum>>.">
                            <button disabled={selectedQuantity === 0} onClick={(e) => handleMinus(pt.priceTypeId)}
                                className="stepper-btn stepper-btn-down" type="button" data-stepper-button="down">
                                <span className="visually-hidden">decrease</span>
                            </button>
                            <input
                                className="stepper-input" data-maxseats={pt.maxSeats}
                                type="text"
                                min="0"
                                value={selectedQuantity}
                                onChange={(e) => handleValueChange(e, pt.priceTypeId)} />
                            <button disabled={selectedQuantity === pt.maxSeats} onClick={() => handlePlus(pt.priceTypeId)}
                                className="stepper-btn stepper-btn-up" type="button" data-stepper-button="up">
                                <span className="visually-hidden">increase</span>
                            </button>
                        </div>
                    </div>
                })
            }
        </>
    );

    return (
        <>
            {qtySelect}
        </>
    );
}

export default QuantitySelectView;